import { render, staticRenderFns } from "./positionDialog.vue?vue&type=template&id=84a35da6&scoped=true"
import script from "./positionDialog.vue?vue&type=script&lang=js"
export * from "./positionDialog.vue?vue&type=script&lang=js"
import style0 from "./positionDialog.vue?vue&type=style&index=0&id=84a35da6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a35da6",
  null
  
)

export default component.exports